import { listPropsSchema } from '../component-catalog.js';
export const listDefinition = {
    type: 'List',
    category: 'data',
    propsSchema: listPropsSchema,
    isDataBacked: true,
    // List uses Handlebars template strings, not direct column refs.
    columnRefManifest: [],
    needsMeasuredDims: true,
    defaultHeight: 400,
    description: 'Renders each row through a Handlebars-style template. Props: sourceDataset (required), template (required — e.g. "{{title}} — {{desc}}").',
};
//# sourceMappingURL=List.js.map